<template>
  <div class="order-detail-container">
    <div class="white-bg padding-left padding-right padding-top border-radius-top">
      <div class="flex justify-between">
        <div class="text-title">
          {{ $t('aOrderDetail.title') }}
        </div>
      </div>

      <!-- 订单基本信息 -->
      <div class="margin-top text-left">
        <el-row :gutter="20">
          <el-col :span="6">
            <div class="form-group">
              <label class="col-form-label">{{ $t('aOrderDetail.orderId') }}：</label>
              <label>{{ aOrderDetailInfo.orderId }}</label>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="form-group">
              <label class="col-form-label">{{ $t('aOrderDetail.totalAmount') }}:</label>
              <label>{{ aOrderDetailInfo.payPrice }}</label>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="form-group">
              <label class="col-form-label">{{ $t('aOrderDetail.orderTime') }}:</label>
              <label>{{ aOrderDetailInfo.createTime }}</label>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="form-group">
              <label class="col-form-label">{{ $t('aOrderDetail.user') }}:</label>
              <label>{{ aOrderDetailInfo.personName }}</label>
            </div>
          </el-col>

          <el-col :span="6">
            <div class="form-group">
              <label class="col-form-label">{{ $t('aOrderDetail.profitSharing') }}:</label>
              <label>{{ aOrderDetailInfo.profitSharing == 'N' ? $t('aOrderDetail.no') : $t('aOrderDetail.yes')
                }}</label>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="form-group">
              <label class="col-form-label">{{ $t('aOrderDetail.platform') }}:</label>
              <label>{{ aOrderDetailInfo.appName }}</label>
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="vc-line-primary margin-top"></div>

      <!-- 标签页 -->
      <div class="margin-top-sm">
        <el-tabs v-model="aOrderDetailInfo._currentTab" @tab-click="changeTab(aOrderDetailInfo._currentTab)">
          <el-tab-pane :label="$t('aOrderDetail.products')" name="aOrderDetailCarts"></el-tab-pane>
          <el-tab-pane :label="$t('aOrderDetail.fees')" name="aOrderDetailFee"></el-tab-pane>
          <el-tab-pane :label="$t('aOrderDetail.ledgers')" name="aOrderDetailLedgers"></el-tab-pane>
          <el-tab-pane :label="$t('aOrderDetail.consignee')" name="aOrderDetailAddress"></el-tab-pane>
          <el-tab-pane :label="$t('aOrderDetail.operations')" name="aOrderDetailEvent"></el-tab-pane>
          <el-tab-pane :label="$t('aOrderDetail.discounts')" name="aOrderDetailDiscounts"></el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <div class="white-bg padding-left padding-right border-radius-bottom">
      <a-order-detail-carts v-if="aOrderDetailInfo._currentTab === 'aOrderDetailCarts'"
        ref="aOrderDetailCarts"></a-order-detail-carts>
      <a-order-detail-fee v-if="aOrderDetailInfo._currentTab === 'aOrderDetailFee'"
        ref="aOrderDetailFee"></a-order-detail-fee>
      <a-order-detail-ledgers v-if="aOrderDetailInfo._currentTab === 'aOrderDetailLedgers'"
        ref="aOrderDetailLedgers"></a-order-detail-ledgers>
      <a-order-detail-address v-if="aOrderDetailInfo._currentTab === 'aOrderDetailAddress'"
        ref="aOrderDetailAddress"></a-order-detail-address>
      <a-order-detail-event v-if="aOrderDetailInfo._currentTab === 'aOrderDetailEvent'"
        ref="aOrderDetailEvent"></a-order-detail-event>
      <a-order-detail-discounts v-if="aOrderDetailInfo._currentTab === 'aOrderDetailDiscounts'"
        ref="aOrderDetailDiscounts"></a-order-detail-discounts>
    </div>
  </div>
</template>

<script>
import { getOrderDetail } from '@/api/order/aOrderDetailApi'
import AOrderDetailCarts from '@/components/order/aOrderDetailCarts/aOrderDetailCarts'
import AOrderDetailFee from '@/components/order/aOrderDetailFee/aOrderDetailFee'
import AOrderDetailLedgers from '@/components/order/aOrderDetailLedgers/aOrderDetailLedgers'
import AOrderDetailAddress from '@/components/order/aOrderDetailAddress/aOrderDetailAddress'
import AOrderDetailEvent from '@/components/order/aOrderDetailEvent/aOrderDetailEvent'
import AOrderDetailDiscounts from '@/components/order/aOrderDetailDiscounts/aOrderDetailDiscounts'

export default {
  name: 'AOrderDetail',
  components: {
    AOrderDetailCarts,
    AOrderDetailFee,
    AOrderDetailLedgers,
    AOrderDetailAddress,
    AOrderDetailEvent,
    AOrderDetailDiscounts
  },
  data() {
    return {
      aOrderDetailInfo: {
        orderId: '',
        appId: '',
        appName: '',
        deduction: '',
        personName: '',
        stateName: '',
        profitSharing: '',
        payPrice: '',
        createTime: '',
        remark: '',
        _currentTab: 'aOrderDetailCarts'
      }
    }
  },
  created() {
    this.aOrderDetailInfo.orderId = this.$route.query.orderId
    if (this.aOrderDetailInfo.orderId) {
      this.listOrderDetail()
    }
  },
  methods: {
    listOrderDetail() {
      const params = {
        page: 1,
        row: 1,
        orderId: this.aOrderDetailInfo.orderId
      }

      getOrderDetail(params).then(response => {
        Object.assign(this.aOrderDetailInfo, response.data[0])
        this.changeTab(this.aOrderDetailInfo._currentTab)
      }).catch(error => {
        console.error('获取订单详情失败:', error)
      })
    },
    changeTab(tab) {
      this.aOrderDetailInfo._currentTab = tab
      setTimeout(() => {
        if (this.$refs[tab]) {
          this.$refs[tab].open({ orderId: this.aOrderDetailInfo.orderId })
        }
      }, 100)
    }
  }
}
</script>

<style scoped>
.order-detail-container {
  background-color: #f5f7fa;
}

.white-bg {
  background-color: #fff;
}

.padding-left {
  padding-left: 20px;
}

.padding-right {
  padding-right: 20px;
}

.padding-top {
  padding-top: 20px;
}

.border-radius-top {
  border-radius: 4px 4px 0 0;
}

.border-radius-bottom {
  border-radius: 0 0 4px 4px;
}

.margin-top {
  margin-top: 20px;
}

.margin-top-sm {
  margin-top: 10px;
}

.flex {
  display: flex;
}

.justify-between {
  justify-content: space-between;
}

.text-title {
  font-size: 18px;
  font-weight: bold;
}

.form-group {
  margin-bottom: 15px;
}

.col-form-label {
  font-weight: bold;
  margin-right: 10px;
}

.vc-line-primary {
  height: 1px;
  background-color: #dcdfe6;
}
</style>